import { createApp } from 'vue';
import ScanWinForm from './components/ScanWinForm.vue';

const mountEl = document.getElementById('scan-win-form');

if (mountEl) {
    const stores = JSON.parse(mountEl.dataset.stores || '[]');
    const csrfName = mountEl.dataset.csrfName || '';
    const csrfToken = mountEl.dataset.csrfToken || '';

    const app = createApp(ScanWinForm, {
        stores,
        csrfName,
        csrfToken,
    });

    app.mount(mountEl);
}
